(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tettra-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeTettraHero = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const slides = [...root.querySelectorAll('[data-tettra-slide]')];
    const dots = [...root.querySelectorAll('[data-tettra-dot]')];
    const previous = root.querySelector('[data-tettra-prev]');
    const next = root.querySelector('[data-tettra-next]');
    let current = 0;
    let timer;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (root.dataset.autoplay !== 'true' || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => show(current + 1), Number(root.dataset.interval));
    };

    previous?.addEventListener('click', () => {
      show(current - 1);
      start();
    });
    next?.addEventListener('click', () => {
      show(current + 1);
      start();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.tettraDot));
      start();
    }));
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  };

  document.querySelectorAll('[data-tettra-hero]').forEach(initializeTettraHero);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tettra-hero]').forEach(initializeTettraHero);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-tettra-slide]');
    if (!slide) return;
    const root = slide.closest('[data-tettra-hero]');
    const slides = [...root.querySelectorAll('[data-tettra-slide]')];
    const dots = [...root.querySelectorAll('[data-tettra-dot]')];
    slides.forEach((item, index) => {
      const active = item === slide;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-hidden', active ? 'false' : 'true');
      dots[index]?.classList.toggle('is-active', active);
      dots[index]?.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
